// extracted by mini-css-extract-plugin
module.exports = {"steps_desktop":"stepillustrations_steps_desktop___ntFQ"};